import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { Catalog } from 'app/Model/Catalog/Catalog';
import { ImportContainer } from 'app/Model/dataProcess/importContainer';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { Router } from "@angular/router";
import DevExpress from "devextreme";
import ContextMenuItem = DevExpress.ui.dxFileManager.ContextMenuItem;
import {DxContextMenuComponent} from "devextreme-angular";
import {ImportContainerService} from "../../../../Services/DataProcess/import-container.service";
import {custom} from "devextreme/ui/dialog";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'np-catalog-tab',
  templateUrl: './catalog-tab.component.html',
  styleUrls: ['./catalog-tab.component.css']
})
export class CatalogTabComponent implements OnInit, OnChanges {
  @Input() container: ImportContainer | null = null;
  @ViewChild('catalogContextMenu', {static: false}) catalogContextMenu: DxContextMenuComponent;
  @Output() inspectCatalog = new EventEmitter<{ container: ImportContainer; catalogId: string }>();

  catalogs: Catalog[] = [];

  compareCatalogId: string | null = null;
  compareCandidates: Catalog[] = [];
  isDragOver: boolean = false;
  archiveCatalogs: { id: string; name: string }[] = [];
  activeCatalogName: string | null = null;
  isArchiveLoading: boolean = false;
  selectedCatalogId: string | null = null;
  importMimeVisible:boolean = false;
  isTemplate:boolean = false;
  contextMenuItems: ContextMenuItem[];

  constructor(private catalogService: CatalogService, private router: Router, public importContainerService: ImportContainerService, public translate: TranslateService) {
    this.contextMenuItems = [
      {
        id: 0,
        text:this.translate.instant( "Katalog anzeigen..."),
        icon: 'glyphicon glyphicon-eye-open',
        beginGroup: true
      },
      {
        id: 1,
        text: this.translate.instant("Medien importieren..."),
        icon: 'glyphicon glyphicon-copy',
        beginGroup: true
      },
      {
        id: 2,
        text: this.translate.instant("Löschen..."),
        icon: 'glyphicon glyphicon-trash',
        beginGroup: true
      },
    ]
  }

  async ngOnInit(): Promise<void> {
    if (this.hasContainerCatalogIds()) {
      await this.loadArchiveCatalogNames();
    }
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['container']) {
      if (this.hasContainerCatalogIds()) {
        await this.loadArchiveCatalogNames();
      } else {
        this.archiveCatalogs = [];
        this.activeCatalogName = null;
        this.selectedCatalogId = null;
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(): void {
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;

    const droppedFiles: File[] = Array.from(event.dataTransfer?.files ?? []);
    this.handleSelectedFiles(droppedFiles);
  }

  onChooseFilesClick(fileInputElement: HTMLInputElement): void {
    fileInputElement.click();
  }

  onFileInputChange(event: Event): void {
    const fileInputElement = event.target as HTMLInputElement;
    const selectedFiles: File[] = Array.from(fileInputElement.files ?? []);

    this.handleSelectedFiles(selectedFiles);
    fileInputElement.value = '';
  }

  private handleSelectedFiles(selectedFiles: File[]): void {
    if (selectedFiles.length === 0) {
      return;
    }

    const readableList = selectedFiles.map(file => `${file.name} (${file.size} B)`);
    console.log('Import-Dateien:', readableList);
  }

  onCompareChanged(event: { value: string | null }): void {
    this.compareCatalogId = event?.value ?? null;
  }

  get compareCatalog(): Catalog | null {
    if (!this.compareCatalogId) {
      return null;
    }
    return this.catalogs.find(c => (c as any).id === this.compareCatalogId) ?? null;
  }

  get hasCatalogs(): boolean {
    return this.catalogs.length > 0;
  }

  onDropAddTop(event: unknown): void {
    console.log('Drop oben hinzugefügt:', event);
  }

  onCatalogOverflowClicked(catalogId: string | null | undefined, event: any): void {

    if (!catalogId || !this.container) {
      return;
    }
    this.catalogContextMenu.instance.option('target', event.event.currentTarget);
    this.catalogContextMenu.instance.option('position', {
      my: 'left top',
      at: 'left bottom',
      offset: '0 5'
    });
    this.catalogContextMenu.instance.show();
    this.selectCatalog(catalogId);
    this.inspectCatalog.emit({
      container: this.container,
      catalogId
    });
  }

  async itemClick(event: any): Promise<void> {

    switch (event.itemIndex) {
      //Katalog anzeigen
      case 0:
        this.router.navigate(['/catalog/' + this.catalogService.loginService.currentUser.customerId + '/' + this.selectedCatalogId + '/info']);
        break;
      //Medien Importieren
      case 1:
        this.importMimeVisible= true;
        break;
      //Löschen
      case 2:
        this.showDeleteDialog(this.selectedCatalogId,this.catalogService.loginService.currentUser.customerId);
        break;
    }
  }
  
  hideImportMime() {
    this.importMimeVisible = false;
  }
   showDeleteDialog(deletedCatalogId: string, customerId: string) {
    let normalCatalogDialog = custom({
      showTitle: true,
      title: this.translate.instant("Katalog löschen"),
      dragEnabled: false,
      messageHtml: this.translate.instant("Wollen Sie den Katalog wirklich löschen?"),

      buttons: [
        {
          text: this.translate.instant("Ja"),
          onClick: async (e) => {
            await this.onDeleteClicked(deletedCatalogId, customerId);
          }
        },
        {
          text: this.translate.instant("Nein"),
        }
      ]
    });
    normalCatalogDialog.show()
  }
  
 async onDeleteClicked( catalogId:string,  customerId:string){
    this.importContainerService.deleteContainerCatalogsByCatalogId(catalogId,customerId);
    this.catalogService.remCatalog(catalogId);
    const result = await this.importContainerService.get(this.container.id, customerId);
    this.container = result ?? null;
  }

  
  async onCatalogJumpClicked(catalogId: string | null | undefined): Promise<void> {
    if (!catalogId) {
      return;
    }

    this.catalogService.selectedCatalogId = catalogId;
    await this.router.navigate(['/catalog/' + this.catalogService.loginService.currentUser.customerId + '/' + catalogId + '/info']);
  }

  onCatalogRowClick(catalogId: string | null | undefined): void {
    if (!catalogId || !this.container) {
      return;
    }

    this.selectCatalog(catalogId);
    this.inspectCatalog.emit({
      container: this.container,
      catalogId
    });
  }

  onArchiveReorder(event: any): void {
    const fromIndex = event.fromIndex;
    const toIndex = event.toIndex;

    if (fromIndex === toIndex) {
      return;
    }

    const updated = [...this.archiveCatalogs];
    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);
    this.archiveCatalogs = updated;
  }

  private selectCatalog(catalogId: string): void {
    this.selectedCatalogId = catalogId;
  }

  private hasContainerCatalogIds(): boolean {
    return !!this.container?.catalogIds && this.container.catalogIds.length > 0;
  }

  private async loadArchiveCatalogNames(): Promise<void> {
    this.isArchiveLoading = true;
    this.archiveCatalogs = [];
    this.activeCatalogName = null;
    this.selectedCatalogId = null;

    try {
      const customerId = this.catalogService.loginService.currentUser.customerId;
      const catalogIds = this.container?.catalogIds ?? [];
      const uniqueIds = [...new Set(catalogIds)].filter(id => !!id);

      if (uniqueIds.length === 0) {
        return;
      }

      const sortedIds = [...uniqueIds].reverse();

      const catalogInfos = await Promise.all(
        sortedIds.map(async id => ({
          id,
          name: await this.catalogService.getCatalogName(id, customerId)
        }))
      );

      const activeId = this.container?.activeCatalogId ?? null;
      const activeCatalog = activeId ? catalogInfos.find(c => c.id === activeId) : undefined;

      this.activeCatalogName = activeCatalog?.name ?? null;

      this.archiveCatalogs = catalogInfos
        .filter(c => c.id !== activeId && !!c.name)
        .map(c => ({
          id: c.id,
          name: c.name as string
        }));
    } finally {
      this.isArchiveLoading = false;
    }
  }
}
